export class GlobalUtils {

	/**
	 * Is the app running in an Iframe?
	 * Introduced as part of INNO-2365
	 */
	public static isInsideIframe(): boolean {
		let isInsideIframe = false;
		try {
			isInsideIframe = !(parent.location === self.location);
		} catch (e) {
			isInsideIframe = true;
		}
		return isInsideIframe;
	}

	/**
	 * Get the string for tootltip placement
	 *
	 * @returns boolean
	 */
	public static getTooltipPlacement(): string {

		if (GlobalUtils.isInsideIframe()) {
			return 'bottom';
		}

		return 'top';
	}
}
